import React from 'react';
import RoleTypeForm from './RoleTypeForm';
import Stack from 'components/common/Stack';
import { trackComponent } from 'telemetry/AppInsights';

const NewRoleTypePage = props => {
  const handleSubmit = response => {
    props.history.push(`/role-types/${response.id}`);
  };

  const handleCancel = () => {
    props.history.push('/role-types');
  };

  return (
    <Stack>
      <RoleTypeForm isCreateMode onSubmit={handleSubmit} onCancel={handleCancel} />
    </Stack>
  );
};

export default trackComponent(NewRoleTypePage, 'New Role Type Page');
